module.exports = {"id":"148203","name":"Žydrūnas Karčemarskas","rating":"76","photo":"./data/images/photos/1/148203.png","club":{"name":"Osmanlıspor","logo":"./data/images/clubs/Osmanlıspor.png"},"positions":["G"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ZydrunasKarcemarskas0.json
// module id = 4477
// module chunks = 0